var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.changeState.apply(null, arguments)
        },
      },
    },
    [
      _c("el-checkbox", {
        attrs: { disabled: "" },
        model: {
          value: _vm.item.config_checked,
          callback: function ($$v) {
            _vm.$set(_vm.item, "config_checked", $$v)
          },
          expression: "item.config_checked",
        },
      }),
      _c("i", { staticClass: "myIcon", class: _vm.icon }),
      _c("div", [
        _vm._v(" " + _vm._s(_vm.name) + " "),
        _vm.isSearch && _vm.item.deptName
          ? _c("div", { staticClass: "deptName" }, [
              _vm._v(_vm._s(_vm.item.deptName)),
            ])
          : _vm._e(),
      ]),
      _vm.item.valueType === "dept"
        ? _c(
            "div",
            {
              staticClass: "fun",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("el-switch", {
                attrs: {
                  title: _vm.item.csonfig_includeChild ? "包含" : "不包含",
                },
                model: {
                  value: _vm.item.config_includeChild,
                  callback: function ($$v) {
                    _vm.$set(_vm.item, "config_includeChild", $$v)
                  },
                  expression: "item.config_includeChild",
                },
              }),
              _c(
                "span",
                {
                  staticClass: "includeChild",
                  class: _vm.item.config_includeChild ? "active" : "",
                  attrs: { title: "下級" },
                  on: {
                    click: function ($event) {
                      return _vm.toChild(_vm.item)
                    },
                  },
                },
                [_vm._v(" 包含下級 ")]
              ),
              _c("i", {
                staticClass: "el-icon-arrow-right",
                attrs: { title: "下級" },
                on: {
                  click: function ($event) {
                    return _vm.toChild(_vm.item)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }